(function () {
  var root = document.querySelector('[data-story]');
  if (!root) return;
  var frame = root.querySelector('.sf__frame');
  var steps = Array.prototype.slice.call(root.querySelectorAll('.step'));
  var segs = Array.prototype.slice.call(root.querySelectorAll('.sf__seg'));
  var back = root.querySelector('[data-story-back]');
  var skip = root.querySelector('[data-story-skip]');
  var backdrop = root.querySelector('.sf__backdrop');
  var cur = 0;

  function track(name) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name });
    if (typeof window.fbq === 'function') window.fbq('trackCustom', name);
  }

  function hydrate(step) {
    var bg = step && step.querySelector('.bg[data-src]');
    if (!bg) return;
    bg.style.setProperty('--bg-img', "url('" + bg.getAttribute('data-src') + "')");
    bg.removeAttribute('data-src');
  }
  function bgUrl(step) {
    var bg = step.querySelector('.bg');
    if (!bg) return null;
    var m = (bg.getAttribute('style') || '').match(/url\(['"]?([^'")]+)/);
    return m ? m[1] : bg.getAttribute('data-src');
  }
  // warm the cache for every later card after load, one at a time
  function preload() {
    var queue = steps.map(bgUrl).filter(Boolean);
    root.querySelectorAll('img[loading="lazy"]').forEach(function (i) { queue.push(i.getAttribute('src')); });
    (function next() { var u = queue.shift(); if (!u) return; var im = new Image(); im.onload = im.onerror = next; im.src = u; })();
  }
  if (document.readyState === 'complete') preload(); else window.addEventListener('load', preload);

  function paint() {
    segs.forEach(function (s, i) { s.classList.toggle('is-done', i <= cur); });
    var step = steps[cur];
    frame.classList.toggle('is-flat', step.dataset.stepKind === 'offer');
    back.hidden = cur === 0;
    skip.hidden = cur === steps.length - 1;
    var u = bgUrl(step);
    if (u) backdrop.style.setProperty('--bd-img', "url('" + u + "')");
  }

  function go(to, fromNext) {
    if (to < 0 || to >= steps.length || to === cur) return;
    var from = steps[cur], into = steps[to];
    if (fromNext) track('step_' + (cur + 1) + '_complete');
    from.classList.add('is-leaving');
    from.classList.remove('is-active');
    setTimeout(function () { from.classList.remove('is-leaving'); }, 380);
    hydrate(into); hydrate(steps[to + 1]);
    into.classList.add('is-active');
    into.scrollTop = 0;
    cur = to;
    if (into.dataset.stepKind === 'offer') track('offer_view');
    var cnt = into.querySelector('[data-count]');
    if (cnt && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var target = +cnt.dataset.count, t0 = performance.now();
      (function up(t) { var k = Math.min(1, (t - t0) / 1100); cnt.textContent = Math.round(target * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(up); })(t0);
      setTimeout(function () { cnt.textContent = target; }, 1400); // lands on the real number even if rAF is paused
    }
    paint();
  }

  root.querySelectorAll('[data-story-next]').forEach(function (b) { b.addEventListener('click', function () { go(cur + 1, true); }); });
  back.addEventListener('click', function () { go(cur - 1, false); });
  skip.addEventListener('click', function () { track('offer_skip'); go(steps.length - 1, false); });
  document.addEventListener('keydown', function (e) {
    if (e.target.closest && e.target.closest('[data-carousel]')) return;
    if (e.key === 'ArrowRight' && cur < steps.length - 1) go(cur + 1, true);
    if (e.key === 'ArrowLeft') go(cur - 1, false);
  });

  // carry ad params (utm_*, affiliate_id, fbclid ...) into the checkout link
  root.querySelectorAll('[data-story-offer]').forEach(function (a) {
    if (location.search) {
      var u = new URL(a.href);
      new URLSearchParams(location.search).forEach(function (v, k) { u.searchParams.set(k, v); });
      a.href = u.toString();
    }
    a.addEventListener('click', function () { track('offer_click'); });
  });

  // reviews carousel: swipe, drag, dots, gentle 5s auto-advance until touched
  var car = root.querySelector('[data-carousel]');
  var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
  if (car && dots.length) {
    var cards = car.querySelectorAll('.rev'), touched = false;
    var idx = function () { return Math.round(car.scrollLeft / (car.clientWidth || 1)); };
    var to = function (i) { car.scrollTo({ left: i * car.clientWidth, behavior: 'smooth' }); };
    car.addEventListener('scroll', function () { var i = Math.min(cards.length - 1, idx()); dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); }); }, { passive: true });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { touched = true; to(i); }); });
    var drag = null;
    car.addEventListener('pointerdown', function (e) { touched = true; if (e.pointerType === 'mouse') { drag = { x: e.clientX, left: car.scrollLeft }; car.classList.add('is-dragging'); } });
    window.addEventListener('pointermove', function (e) { if (drag) car.scrollLeft = drag.left - (e.clientX - drag.x); });
    window.addEventListener('pointerup', function () { if (!drag) return; drag = null; car.classList.remove('is-dragging'); to(idx()); });
    car.addEventListener('touchstart', function () { touched = true; }, { passive: true });
    car.addEventListener('keydown', function (e) { touched = true; if (e.key === 'ArrowRight') to(Math.min(cards.length - 1, idx() + 1)); if (e.key === 'ArrowLeft') to(Math.max(0, idx() - 1)); });
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce) setInterval(function () { if (touched || steps[cur].dataset.stepKind !== 'proof') return; to((idx() + 1) % cards.length); }, 5000);
  }

  // confetti for the offer card, brand palette
  var conf = root.querySelector('.confetti');
  if (conf) {
    var colors = ['#F4842B', '#B85727', '#4E7D3F', '#A5B99C', '#D2B9A6', '#2D4C26'];
    for (var i = 0; i < 52; i++) {
      var p = document.createElement('span'), round = i % 6 === 0, w = 6 + Math.round(Math.random() * 5);
      p.className = 'confetti__piece' + (round ? ' is-round' : '');
      p.style.cssText = 'left:' + (Math.random() * 100).toFixed(2) + '%;width:' + w + 'px;height:' + (round ? w : w + Math.round(Math.random() * 8)) + 'px;background:' + colors[i % colors.length] +
        ';--delay:' + (Math.random() * 1.1).toFixed(2) + 's;--dur:' + (2.6 + Math.random() * 1.9).toFixed(2) + 's;--drift:' + Math.round(Math.random() * 80 - 40) + 'px;--spin:' + Math.round(540 + Math.random() * 540) + 'deg';
      conf.appendChild(p);
    }
  }

  // offer countdown: 10 minutes per visitor session, restarts quietly when it runs out
  var cd = root.querySelector('[data-countdown]');
  if (cd) {
    var KEY = 'mo_gel_offer_until', until = 0;
    try { until = +sessionStorage.getItem(KEY) || 0; } catch (e) {}
    if (until < Date.now()) { until = Date.now() + 600000; try { sessionStorage.setItem(KEY, String(until)); } catch (e) {} }
    var tick = function () {
      var left = Math.max(0, until - Date.now());
      if (!left) { until = Date.now() + 600000; try { sessionStorage.setItem(KEY, String(until)); } catch (e) {} left = 600000; }
      var m = Math.floor(left / 60000), sec = Math.floor(left / 1000) % 60;
      cd.textContent = (m < 10 ? '0' : '') + m + ':' + (sec < 10 ? '0' : '') + sec;
    };
    tick(); setInterval(tick, 1000);
  }

  hydrate(steps[0]); hydrate(steps[1]);
  steps[0].classList.add('is-active');
  paint();
})();
